module.exports = __webpack_public_path__ + "static/Apercu-Bold-eb01e9721aff7b04e38efea2fd2f59d5.ttf";